import { render, staticRenderFns } from "./RecoveredUserForm.vue?vue&type=template&id=63e5ac0e"
import script from "./RecoveredUserForm.vue?vue&type=script&lang=js"
export * from "./RecoveredUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports